import { required, email, minLength } from 'vuelidate/lib/validators'
// import passwordComplexity from '@/utils/customValidators/passwordComplexity'

export default {
  register: {
    name: {
      required
    },
    genre: {
      required
    },
    phone: {
      required
    },
    country_register: {
      required
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
      // passwordComplexity
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/register/dweller/resources/validations.js